import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function ArmDeviceIcon({ className }: IconBaseType) {
  return (
    <svg
      className={cn("w-4.5 h-4.5", className)}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.24118 6.52509L3.87504 11.4751H6.30436V6.52509H4.24118Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5234 13.275H7.47639C6.85036 13.275 6.34338 12.8759 6.31058 12.375H3.80849L3.71617 13.6254C3.65821 14.4081 4.27661 15.075 5.0601 15.075H12.9395C13.7232 15.075 14.3416 14.4081 14.2836 13.6254L14.1911 12.375H11.6892C11.6567 12.8824 11.1472 13.275 10.5234 13.275Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6954 6.52505V11.475H14.1247L13.7586 6.52505H11.6954Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.47632 4.72505H10.5234C11.1469 4.72505 11.6561 5.126 11.6892 5.62505H13.6921L13.5848 4.17537C13.5326 3.47045 12.9464 2.92505 12.2408 2.92505H5.75906C5.05329 2.92505 4.46702 3.47045 4.41491 4.17537L4.30776 5.62505H6.31052C6.34286 5.126 6.84153 4.72505 7.47632 4.72505Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0155 5.62505H7.98422C7.54665 5.62505 7.20297 5.96255 7.20297 6.37497V11.6251C7.20297 12.0393 7.55271 12.375 7.98422 12.375H10.0155C10.4452 12.375 10.797 12.045 10.797 11.6251V6.37497C10.797 5.96255 10.4452 5.62505 10.0155 5.62505Z"
        fill="currentColor"
      />
    </svg>
  );
}
